"use strict";
require('./CompanyCustomerServiceService.js');
var moment      = require("moment");
CompanyCustomerServiceListCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  'services',
  'serviceTypes',
  'info',
  '$translate',
  'CompanyCustomerServiceService',
  'filterManager',
  'CompanyUserService',
  'growl'];
var LIMIT = 20;

function CompanyCustomerServiceListCtrl(
  $scope,
  $stateParams,
  $state,
  services,
  serviceTypes,
  info,
  $translate,
  CompanyCustomerServiceService,
  filterManager,
  CompanyUserService,
  growl) {

  $scope.services = services;

  $scope.serviceTypes = serviceTypes;
  $scope.page = $stateParams.page|0;
  $scope.info = info;

  $scope.currentManager = filterManager;

  if ($scope.services.length === (LIMIT + 1)) {
    $scope.more = true;
    $scope.services.pop();
  }

  $scope.currentServiceId = $stateParams.typeId || "";

  $scope.delete = function(id, index) {
    CompanyCustomerServiceService.delete({companyId: $stateParams.companyId, serviceTypeId: id}, function(){
      $scope.services.splice(index, 1);
      growl.addSuccessMessage($translate.instant('customer.service-type.delete-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('customer.service-type.delete-failure'));
    });
  };

  $scope.filterName = $stateParams.name || "";

  $scope.search = function() {
    var params = {
      name: $scope.filterName,
      page: null
    };
    if ($scope.currentManager) {
      params.manager = $scope.currentManager.id;
    }
    $state.go('root.company.customer-service.list', params);
  };

  $scope.queryManager = function(filter) {
    CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users){
        $scope.managers = users;
    });
  };
}

CompanyCustomerServiceListCtrl.resolve = {
  services: [
  '$stateParams',
  'CompanyCustomerServiceService',
  function($stateParams, CompanyCustomerServiceService) {
    return CompanyCustomerServiceService.query({
      companyId: $stateParams.companyId,
      limit: (LIMIT + 1),
      name: $stateParams.name ||  null,
      typeId: $stateParams.typeId || null,
      manager: $stateParams.manager || null,
      offset: ($stateParams.page|0) * LIMIT}).$promise;
  }],
  serviceTypes: ['$stateParams', 'CompanyCustomerServiceTypeService', function($stateParams, CompanyCustomerServiceTypeService){
    return CompanyCustomerServiceTypeService.query({
      companyId: $stateParams.companyId,
      limit: 1000
    }).$promise;
  }],
  filterManager: ['$stateParams', 'CompanyUserService', function($stateParams, CompanyUserService) {
    if ($stateParams.manager) {
      return CompanyUserService.get({
        companyId: $stateParams.companyId,
        userId: $stateParams.manager
      }).$promise;
    }
    return null;
  }]
};

module.exports  = CompanyCustomerServiceListCtrl;

angular.module("dokiv")
  .controller("CompanyCustomerServiceListCtrl", CompanyCustomerServiceListCtrl)
  .filter('lastcontact', function() {
    return function(input) {
      if (input.lastContactDate && input.expiredContactDate) {
        var expiredContactDate = moment(new Date(input.expiredContactDate)).format("YYYYMMDD");
        var today = moment().format("YYYYMMDD");
        if (expiredContactDate < today) {
          return '#f26a5d';
        }
      }
      return '';
    };
  });



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customer-service/CompanyCustomerServiceListCtrl.js
// module id = 332
// module chunks = 0